const Color = {
    /**
     * String to HEX
     */
    strToHex: function (_str) {
        _str = _str.replace(/^#/, "");
        return parseInt(_str, 16);
    },
    /**
     * RGB to HEX
     */
    rgbToHex: function rgbToHex(_r, _g, _b) {
        _r = Math.min(255, Math.max(0, _r));
        _g = Math.min(255, Math.max(0, _g));
        _b = Math.min(255, Math.max(0, _b));
        return ((_r << 16) | (_g << 8) | _b).toString(16).padStart(6, "0");
    },
    /**
     * HSL to HEX
     */
    hslToHex: function (_h, _s, _l) {
        _h = ((_h % 360) + 360) % 360;
        _s = Math.min(100, Math.max(0, _s));
        _l = Math.min(100, Math.max(0, _l));

        const C = ((1 - Math.abs(2 * _l - 1)) * _s) / 100;
        const X = C * (1 - Math.abs(((_h / 60) % 2) - 1));
        const m = _l / 100 - C / 2;

        let r, g, b;
        if (_h >= 0 && _h < 60) {
            r = C;
            g = X;
            b = 0;
        } else if (_h >= 60 && _h < 120) {
            r = X;
            g = C;
            b = 0;
        } else if (_h >= 120 && _h < 180) {
            r = 0;
            g = C;
            b = X;
        } else if (_h >= 180 && _h < 240) {
            r = 0;
            g = X;
            b = C;
        } else if (_h >= 240 && _h < 300) {
            r = X;
            g = 0;
            b = C;
        } else {
            r = C;
            g = 0;
            b = X;
        }

        r = Math.round((r + m) * 255);
        g = Math.round((g + m) * 255);
        b = Math.round((b + m) * 255);

        return this.rgbToHex(r, g, b);
    },
    /**
     * HSB to HEX
     */
    hsbToHex: function (_h, _s, _b) {
        _h = ((_h % 360) + 360) % 360;
        _s = Math.min(100, Math.max(0, _s));
        _b = Math.min(100, Math.max(0, _b));

        const C = (_b / 100) * (_s / 100);
        const X = C * (1 - Math.abs(((_h / 60) % 2) - 1));
        const m = _b / 100 - C;

        let r, g, b;
        if (_h >= 0 && _h < 60) {
            r = C;
            g = X;
            b = 0;
        } else if (_h >= 60 && _h < 120) {
            r = X;
            g = C;
            b = 0;
        } else if (_h >= 120 && _h < 180) {
            r = 0;
            g = C;
            b = X;
        } else if (_h >= 180 && _h < 240) {
            r = 0;
            g = X;
            b = C;
        } else if (_h >= 240 && _h < 300) {
            r = X;
            g = 0;
            b = C;
        } else {
            r = C;
            g = 0;
            b = X;
        }

        r = Math.round((r + m) * 255);
        g = Math.round((g + m) * 255);
        b = Math.round((b + m) * 255);

        return this.rgbToHex(r, g, b);
    },
    /**
     * To Hex
     */
    toHex: function (_x, _y, _z, _mode) {
        switch (_mode) {
            case "STR" || "str":
                return this.strToHex(_x, _y, _z);
                break;
            case "RGB" || "rgb":
                return this.rgbToHex(_x, _y, _z);
                break;
            case "HSB" || "hsb":
                return this.hsbToHex(_x, _y, _z);
                break;
            case "HSL" || "hsl":
                return this.hslToHex(_x, _y, _z);
                break;
        }
    },
    /**
     * Interpolate Color
     */
    lerpColor: function (_from, _to, _progress) {
        const fromHex = parseInt(_from.replace(/^#/, ""), 16);
        const toHex = parseInt(_to.replace(/^#/, ""), 16);
        const fromRed = (fromHex >> 16) & 255;
        const fromGreen = (fromHex >> 8) & 255;
        const fromBlue = fromHex & 255;
        const toRed = (toHex >> 16) & 255;
        const toGreen = (toHex >> 8) & 255;
        const toBlue = toHex & 255;
        const lerpedRed = fromRed + (toRed - fromRed) * _progress;
        const lerpedGreen = fromGreen + (toGreen - fromGreen) * _progress;
        const lerpedBlue = fromBlue + (toBlue - fromBlue) * _progress;

        return this.rgbToHex(lerpedRed, lerpedGreen, lerpedBlue);
    },
};

export default Color;
